import { render, staticRenderFns } from "./RoofCalwidgetCode.vue?vue&type=template&id=22e408a1&scoped=true"
import script from "./RoofCalwidgetCode.vue?vue&type=script&lang=js"
export * from "./RoofCalwidgetCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e408a1",
  null
  
)

export default component.exports